module.exports = __webpack_public_path__ + "static/img/3979_phase_function_Paper_PointsHejduk_Prediction.27f997d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3979_phase_function_Paper_PointsHejduk_Prediction.png
// module id = a0z9
// module chunks = 0